import { APIClasses } from "../../../../../legacyComponents/util"

export default async function getBanks() {
	try {
		return await APIClasses.Employer.BankAccounts.getBanks()
	} catch (error) {
		console.error(error)
		return new Map()
	}
}
